import { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { useQueryGetAllUserGroups } from 'api/queries/getAllUserGroups.query';

import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/Settings/Components/UserGroups/components/userGroups.module.scss';
import { columns, defaultColumn, initialState } from 'components/Settings/Components/UserGroups/userGroups.utils';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const UserGroups = () => {
    const { ability } = useUserHook();
    const {
        data: userGroups,
        isLoading,
        isFetching,
    } = useQueryGetAllUserGroups({ enabled: ability.can('view', 'UserManagement') });
    const history = useHistory();
    const { pathname } = useLocation();

    const handleNew = () => {
        history.push(`${pathname}/${settingsConfig.userGroupsNew.link}`);
    };

    const data = useMemo(() => {
        return userGroups || [];
    }, [userGroups]);

    return (
        <WidgetWithTitle
            title={'User Groups'}
            titleComponents={[
                <div className={classes.titleActions} key={'createUser'}>
                    <Button onClick={handleNew}>Create New User Group</Button>
                </div>,
            ]}
        >
            <div className={classes.container}>
                <MainTable
                    columns={columns}
                    data={data}
                    initialState={initialState}
                    defaultColumn={defaultColumn}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </WidgetWithTitle>
    );
};
